var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Progress } from 'antd';
import 'antd/dist/antd.css';
export const LineProgressBar = (_a) => {
    var { id, percent = 50, strokeWidth = 10, rtl } = _a, props = __rest(_a, ["id", "percent", "strokeWidth", "rtl"]);
    const dir = rtl ? 'rtl' : 'ltr';
    return (_jsx(_Fragment, { children: _jsx(Progress, { percent: percent, showInfo: false, style: { direction: dir }, trailColor: "#F2F4F8", strokeColor: "#008CFF", strokeWidth: strokeWidth }, void 0) }, void 0));
};
